import { isBedbankOffer, isHotel } from 'lib/offer/offerTypes'

export interface BreadcrumbProperty {
  propertyId: string
  type: 'le' | 'bedbank'
}

export function isBreadcrumbSourceLocale(locale: string | undefined): boolean {
  return !locale || locale === 'en' || locale.startsWith('en-')
}

export function getBreadcrumbPropertyFromOffer(offer: App.AnyOffer | undefined): BreadcrumbProperty | undefined {
  if (!isHotel(offer) || !offer.property?.id) return undefined
  return { propertyId: offer.property.id, type: isBedbankOffer(offer) ? 'bedbank' : 'le' }
}
